export const GET_PRICING_OPTIONS_REQUEST = "GET_PRICING_OPTIONS_REQUEST";
export const GET_PRICING_OPTIONS_SUCCESS = "GET_PRICING_OPTIONS_SUCCESS";
export const GET_PRICING_OPTIONS_FAILED = "GET_PRICING_OPTIONS_FAILED";
